export function getEdgeVisualStyle(
  fromNode,
  toNode,
  { isCriticalEdge = false, isInChain = false, isSubTaskEdge = false } = {},
) {
  // 🔴 Critical edges override everything
  if (isCriticalEdge) {
    return { color: "#FF0000", strokeDasharray: "0", strokeWidth: 3 };
  }

  // 🔵 Chain highlighting edges override everything except critical
  if (isInChain) {
    return { color: "#1A73E8", strokeDasharray: "0", strokeWidth: 3 };
  }

  // 🔶 Subtask (hierarchy) edges → dotted
  // if (isSubTaskEdge) {
  //   return { color: "#1A73E8", strokeDasharray: "6 4", strokeWidth: 3 };
  // }

  // if (isSubTaskEdge) {
  //   const depth = toNode?.hierarchyDepth ?? 1;
  //   const hue = (depth * 137.508) % 360;
  //   const color = `hsl(${hue}, 70%, 45%)`;
  //   return { color, strokeDasharray: "6 4", strokeWidth: 1.5 };
  // }
  function hashHue(str) {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      hash = (hash * 31 + str.charCodeAt(i)) & 0xffffffff;
    }
    return Math.abs(hash) % 360;
  }
  if (isSubTaskEdge) {
    const depth = toNode?.hierarchyDepth ?? 1;
    const parentId = fromNode?.id || "";
    const baseHue = hashHue(parentId); // unique per parent task
    const hue = (baseHue + depth * 40) % 360; // shift per depth level
    const color = `hsl(${hue}, 70%, 45%)`;
    return { color, strokeDasharray: "6 4", strokeWidth: 1.5 };
  }


  const fromType = (fromNode?.subtitle || "").toLowerCase();
  const toType = (toNode?.subtitle || "").toLowerCase();

  // 🎨 Phase ↔ Task
  if (fromType.includes("phase") && toType.includes("task"))
    return { color: "#8E44AD", strokeDasharray: "0", strokeWidth: 2 };

  if (fromType.includes("task") && toType.includes("phase"))
    return { color: "#8E44AD", strokeDasharray: "6 4", strokeWidth: 2 };

  // 🎨 Task ↔ Milestone
  if (fromType.includes("task") && toType.includes("milestone"))
    return { color: "#D35400", strokeDasharray: "0", strokeWidth: 2 };

  if (fromType.includes("milestone") && toType.includes("task"))
    return { color: "#D35400", strokeDasharray: "6 4", strokeWidth: 2 };

  // 🎨 Phase ↔ Milestone
  if (fromType.includes("phase") && toType.includes("milestone"))
    return { color: "#16A085", strokeDasharray: "0", strokeWidth: 2 };

  if (fromType.includes("milestone") && toType.includes("phase"))
    return { color: "#16A085", strokeDasharray: "2 4", strokeWidth: 2 };

  // Default (task → task or unknown)
  return { color: "#090909ff", strokeDasharray: "0", strokeWidth: 2 };
}
